import React, { useEffect, useState } from 'react';
import { AddCircleOutline, ArrowBackIos } from '@mui/icons-material';
import { useNavigate, useParams } from 'react-router-dom';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { Tooltip } from '@mui/material';
import { Header } from '../../../components/header/header';
import {
  StyledBackButtonNavigator,
  StyledHeaderContainer,
  StyledTitleHeader
} from '../../../components/layout/main/mainStyles';
import Strings from '../../../i18n';
import { ButtonIconStyled } from '../../devices/devicesStyles';
import {
  useGetSequenceListByLocationMutation,
  useResaveSequencesMutation
} from '../../../services/sequences/sequencesService';
import { LightShowsListTemplate } from '../../../templates/applications/lightShows/lightShowsListTemplate';
import { ISequence } from '../../../types/sequences/sequencesInterface';
import { RightSideBar } from '../../../components/layout/rightSideBar/rightSideBar';
import { viewRightSideBarEnum } from '../../../constants/sidebarEnums';
import { LightShowsDetails } from '../../../templates/applications/lightShows/lightShowDetails/lightShowDetails';

export const LightsShowsView = () => {
  const navigate = useNavigate();
  const { locationId } = useParams();
  const [selectedLightShows, setSelectedLightShows] = useState<ISequence[]>([]);
  const [openSideBar, setOpenSideBar] = useState(false);
  const [sideBarOpenFor, setSideBarOpenFor] = useState(
    viewRightSideBarEnum.addScene
  );
  const [showSelectTypeAddLightShow, setShowSelectTypeAddLightShow] =
    useState(false);

  const openRightSideBarForMethod = (method: number) => {
    setSideBarOpenFor(method);
    setOpenSideBar(true);
  };

  const [getSequences, { data: sequences, isLoading: isLoadingSequences }] =
    useGetSequenceListByLocationMutation();
  const [resaveSequences] = useResaveSequencesMutation();

  useEffect(() => {
    if (locationId) {
      getSequences(+locationId);
    }
  }, []);

  const reloadTable = () => {
    if (locationId) {
      getSequences(+locationId);
    }
  };

  const switchComponentToShowRightSideBar = () => {
    switch (sideBarOpenFor) {
      case viewRightSideBarEnum.addLightShow:
        return <p />;
      case viewRightSideBarEnum.lightShowDetails:
        return (
          <LightShowsDetails
            lightShow={selectedLightShows[0]}
            setOpenSideBar={setOpenSideBar}
            openSideBar={openSideBar}
            setSelectedLightShows={setSelectedLightShows}
            selectedLightShows={selectedLightShows}
            reloadTable={reloadTable}
          />
        );
      default:
        return <p />;
    }
  };

  useEffect(() => {
    if (selectedLightShows.length === 1) {
      openRightSideBarForMethod(viewRightSideBarEnum.lightShowDetails);
    } else if (selectedLightShows.length > 1) {
      openRightSideBarForMethod(
        viewRightSideBarEnum.multipleOrganizationsDetails
      );
    } else {
      openRightSideBarForMethod(viewRightSideBarEnum.empty);
      setOpenSideBar(false);
    }
  }, [selectedLightShows]);

  const redirectToAddLightShow = (type: string) => {
    if (locationId) {
      navigate(
        `/locations/${locationId}/applications/light_shows/add?type=${type}`
      );
    }
  };

  return (
    <>
      <Header>
        <StyledHeaderContainer>
          <div className="row justify-content-between">
            <div className="col-4 text-left">
              <StyledBackButtonNavigator
                size="small"
                onClick={() => navigate(-1)}
              >
                <ArrowBackIos />
              </StyledBackButtonNavigator>
            </div>
            <div className="col-4 text-center">
              <StyledTitleHeader align="center">
                {Strings.lightShows.title}
              </StyledTitleHeader>
            </div>
            <div className="col-4 text-right">
              <Tooltip title={Strings.lightShows.resave}>
                <ButtonIconStyled
                  size="small"
                  onClick={() => {
                    resaveSequences(Number(locationId));
                  }}
                >
                  <SaveAltIcon />
                </ButtonIconStyled>
              </Tooltip>
              <Tooltip title={Strings.lightShows.addLightShow}>
                <ButtonIconStyled
                  size="small"
                  onClick={() => {
                    setShowSelectTypeAddLightShow(true);
                  }}
                >
                  <AddCircleOutline />
                </ButtonIconStyled>
              </Tooltip>
            </div>
          </div>
        </StyledHeaderContainer>
      </Header>
      <LightShowsListTemplate
        selectedLightShows={selectedLightShows}
        setSelectedLightShows={setSelectedLightShows}
        lightShows={Array.isArray(sequences) ? sequences : []}
        isLoading={isLoadingSequences}
      />
      <RightSideBar
        open={openSideBar}
        onMenuClose={() => {
          setOpenSideBar(false);
        }}
      >
        {switchComponentToShowRightSideBar()}
      </RightSideBar>
      <Dialog
        header={Strings.lightShows.howToAddLigthShow}
        visible={showSelectTypeAddLightShow}
        onHide={() => {
          setShowSelectTypeAddLightShow(false);
        }}
        style={{ width: '50vw' }}
        breakpoints={{ '960px': '75vw', '641px': '100vw' }}
      >
        <div className="row">
          <div className="col-6 text-center">
            <Button
              size="small"
              onClick={() => {
                redirectToAddLightShow('Custom');
              }}
              severity="secondary"
              outlined
              label={Strings.lightShows.customLightShow}
            />
            <p>{Strings.lightShows.addLightShowDescription}</p>
          </div>
          <div className="col-6 text-center">
            <Button
              size="small"
              onClick={() => {
                redirectToAddLightShow('Advanced');
              }}
              severity="secondary"
              outlined
              label={Strings.lightShows.advancedLightShow}
            />
            <p>{Strings.lightShows.forMoreCustomizableOptions}</p>
          </div>
        </div>
      </Dialog>
    </>
  );
};
